import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ContactSummary, UnallocatedUserId } from '@jms/model';

@Component({
    selector: 'contact-item-picker',
    templateUrl: './contact.item.picker.component.html',
    styleUrls: ['./contact.item.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContactItemPickerComponent implements OnInit {

  @Input() public entity: ContactSummary;
  @Input() public emptyText = 'Not Set';
  @Input() public readMode = false;    // Not used ?
  @Input() public clearTemplate = false;
  @Input() public showFull = false;
  @Input() public showToolTip = false; // Not used ?
  @Input() public appendTo: null;      // Not used ?

  @Output() public clear = new EventEmitter<any>();
  @Output() public delete = new EventEmitter<ContactSummary>();

  public unallocatedUserId = UnallocatedUserId;


  constructor() { }

  ngOnInit(): void { }

  public onClear(item: any) {
    this.clear.emit(item);
  }

  public onShowFull(show) {
    this.showFull = show;
  }

}
